import { CURRENT_REGION } from 'common/config/regions/config';
import { Regions } from 'common/config/regions/types';

interface Links {
  termsAndConditions: string;
  NDA: string;
  privacyPolicy: string;
  contactsAndImprint: string;
  knowledgeBase: string;
  qualityControlGuide: string;
  qualityGuideline: string;
  qualityInspectionTypes: string;
  allAboutStates: string;
  learnBtnVideo: string;
  rating: string;
  packagingGuide: string;
  paymentRules: string;
  invoiceTemplate: string;
  certificatesInfo: string;
}
const links: Record<Regions, Links> = {
  [Regions.EU]: {
    termsAndConditions: 'https://knowledgebase.xometry.eu/books/9-legal-documents/page/terms-and-conditions',
    NDA: 'https://knowledgebase.xometry.eu/books/9-legal-documents/page/non-disclosure-agreement-nda',
    privacyPolicy: 'https://xometry.eu/en/policy/',
    contactsAndImprint: 'https://xometry.eu/en/contacts/',
    knowledgeBase: 'https://knowledgebase.xometry.eu/',
    qualityControlGuide:
      'https://knowledgebase.xometry.eu/books/8-quality-control/page/quality-control-report-step-by-step',
    qualityGuideline: 'https://knowledgebase.xometry.eu/books/quality-control/page/what-needs-to-be-checked',
    qualityInspectionTypes:
      'https://knowledgebase.xometry.eu/books/8-quality-control/page/quality-inspection-types-requirements',
    allAboutStates:
      'https://knowledgebase.xometry.eu/books/2-eu-partners-main-instructions/page/all-about-states-what-is-probation-what-is-trusted',
    learnBtnVideo: 'https://www.youtube.com/embed/YigzCbTBu_E',
    rating: 'https://knowledgebase.xometry.eu/books/2-eu-partners-main-instructions/page/what-is-rating',
    packagingGuide: 'https://knowledgebase.xometry.eu/books/7-packaging-guide',
    paymentRules:
      'https://knowledgebase.xometry.eu/books/2-eu-partners-main-instructions/page/payment-and-invoicing-rules',
    invoiceTemplate: 'https://knowledgebase.xometry.eu/books/3-non-eu-partners-main-instructions/page/invoice-template',
    certificatesInfo: 'https://knowledgebase.xometry.eu/books/8-quality-control/chapter/certificates',
  },
  [Regions.SG]: {
    termsAndConditions: 'https://knowledgebase.xometry.sg/books/8-legal-documents/page/terms-and-conditions',
    NDA: 'https://knowledgebase.xometry.sg/books/8-legal-documents/page/non-disclosure-agreement-nda',
    privacyPolicy: 'https://xometry.sg/privacy-policy/',
    contactsAndImprint: 'https://xometry.sg/about-us/',
    knowledgeBase: 'https://knowledgebase.xometry.sg/',
    qualityControlGuide:
      'https://knowledgebase.xometry.sg/books/5-quality-control/page/quality-control-report-step-by-step',
    qualityGuideline: 'https://knowledgebase.xometry.sg/books/6-quality-control/page/what-needs-to-be-checked',
    qualityInspectionTypes: 'https://knowledgebase.xometry.sg/books/5-quality-control/page/general-information',
    allAboutStates:
      'https://knowledgebase.xometry.sg/books/job-board/page/all-about-statuses-what-is-probation-what-is-trusted',
    learnBtnVideo: 'https://www.youtube.com/embed/YigzCbTBu_E',
    rating: 'https://knowledgebase.xometry.sg/books/2-india-partners-main-instructions/page/what-is-rating',
    packagingGuide: 'https://knowledgebase.xometry.sg/books/3-packaging-guide',
    paymentRules: 'https://knowledgebase.xometry.sg/books/4-payment-and-invoicing/page/payment-and-invoicing-rules',
    invoiceTemplate: 'https://knowledgebase.xometry.sg/books/4-payment-and-invoicing/page/invoice-template',
    certificatesInfo: 'https://knowledgebase.xometry.sg/books/6-quality-control/chapter/certificates',
  },
  [Regions.TR]: {
    termsAndConditions:
      'https://knowledgebase.xometry.com.tr/books/7-yasal-dokumanlar/chapter/tedarikci-cerceve-sozlesmesi',
    NDA: 'https://knowledgebase.xometry.com.tr/books/7-yasal-dokumanlar/chapter/gizlilik-sozlesmesi',
    privacyPolicy: 'https://xometry.com.tr/tr/gizlilik/',
    contactsAndImprint: 'https://xometry.com.tr/tr/iletisim/',
    knowledgeBase: 'https://knowledgebase.xometry.com.tr/',
    qualityControlGuide:
      'https://knowledgebase.xometry.com.tr/books/5-kalite-kontrol/page/kalite-kontrol-raporu-nasil-doldurulur',
    qualityGuideline:
      'https://knowledgebase.xometry.com.tr/books/5-kalite-kontrolu/page/neyin-kontrol-edilmesi-gerekiyor',
    qualityInspectionTypes: 'https://knowledgebase.xometry.com.tr/books/5-kalite-kontrol/page/genel-bilgiler',
    allAboutStates:
      'https://knowledgebase.xometry.eu/books/2-eu-partners-main-instructions/page/all-about-states-what-is-probation-what-is-trusted',
    learnBtnVideo: 'https://www.youtube.com/embed/AixoBx49QYc',
    rating: 'https://knowledgebase.xometry.com.tr/books/2-profiliniz/page/genel-degerlendirmepuanlama-nedir',
    packagingGuide: 'https://knowledgebase.xometry.com.tr/books/4-paketleme-ve-kargo',
    paymentRules:
      'https://knowledgebase.xometry.com.tr/books/6-odeme-ve-faturalandirma-kurallari/page/odeme-ve-faturalandirma-kurallari',
    invoiceTemplate: 'https://knowledgebase.xometry.com.tr/books/5-kalite-kontrolu/page/kalite-kontrol-sablonu',
    certificatesInfo: 'https://knowledgebase.xometry.com.tr/books/5-kalite-kontrolu/chapter/sertifikalar',
  },
  [Regions.UK]: {
    termsAndConditions: 'https://knowledgebase.xometry.uk/books/7-legal-documents/page/terms-and-conditions',
    NDA: 'https://knowledgebase.xometry.uk/books/7-legal-documents/page/non-disclosure-agreement-nda',
    privacyPolicy: 'https://xometry.uk/policy/',
    contactsAndImprint: 'https://xometry.uk/contacts/',
    knowledgeBase: 'https://knowledgebase.xometry.uk/',
    qualityControlGuide:
      'https://knowledgebase.xometry.uk/books/4-quality-control/page/quality-control-report-step-by-step',
    qualityGuideline: 'https://knowledgebase.xometry.uk/books/4-quality-control/page/what-needs-to-be-checked',
    qualityInspectionTypes:
      'https://knowledgebase.xometry.uk/books/4-quality-control/page/quality-inspection-types-requirements',
    allAboutStates:
      'https://knowledgebase.xometry.uk/books/2-using-xometry/page/all-about-states-what-is-probation-what-is-trusted ',
    learnBtnVideo: 'https://www.youtube.com/embed/k2yknHtPwf4',
    rating: 'https://knowledgebase.xometry.uk/books/2-using-xometry/page/what-is-rating',
    packagingGuide: 'https://knowledgebase.xometry.uk/books/3-packaging-guide',
    paymentRules: 'https://knowledgebase.xometry.uk/books/2-using-xometry/chapter/payment-and-invoicing',
    invoiceTemplate:
      'https://docs.google.com/spreadsheets/d/1xo2s02bU8od4f5H-XKgSqbBsyroVTYSs/edit?gid=555376911#gid=555376911',
    certificatesInfo: 'https://knowledgebase.xometry.uk/books/4-quality-control/chapter/certificates',
  },
};

export const regionLinks = links[CURRENT_REGION];
